<template>
  <collapse-panel
    v-model:is-open="isFooterOpen"
    class="footer"
    :border="false"
    body-class="collapse-body"
    header-class="collapse-header"
    header-chevron-class="collapse-chevron"
    header-content-class="collapse-header-content">
    <template #header>
      <div class="footer__header">
        {{ $t('services.services.footer.title') }}
      </div>
    </template>
    <template #body>
      <slot name="footer" />
    </template>
  </collapse-panel>
</template>

<script>
import CollapsePanel from '@/utils/components/CollapsePanel.vue';

export default {
  name: 'serviceFooter',
  components: {
    CollapsePanel,
  },
  data() {
    return {
      isFooterOpen: false,
    };
  },
};
</script>

<style scoped lang="scss">
:deep(.collapse-body) {
  padding: 0;
}
:deep(.collapse-chevron) {
  display: inline-block;
  margin-left: 20px;
}
:deep(.collapse-header-content) {
  display: inline-block;
}
:deep(.collapse-header) {
  display: block;
  text-align: center;
}

.footer {
  border-top: solid 1px var(--nxt-color-grey);
  background-color: var(--nxt-color-white);
  margin-top: 20px;
  &__header {
    font-weight: 700;
    text-align: center;
  }
}
</style>
